export default {
  3: 'Desktop',
  4: 'Mobile',
  5: 'Console',
} as const;
